export function isRadioBridgeReviewReady(intake, displayedResult) {
  return Boolean(intake?.paymentStatus === 'paid' && intake?.submittedAt &&
    intake?.serviceWindow?.state === 'playable' && !intake.serviceWindow.blocker &&
    !intake.serviceWindow.interimHold && !displayedResult &&
    !['earned_next_move', 'not_yet', 'hold_second_listen'].includes(intake?.releasedListenResult?.decision) &&
    ['ready_for_curator_listen', 'hitlab_candidate', 'street_drop_candidate'].includes(intake.status));
}
